var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{style:(("height: " + _vm.height + "; overflow:auto;")),attrs:{"outlined":_vm.outlined,"flat":!_vm.outlined}},[_c('div',{class:{ 'ma-3': _vm.outlined }},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }